module.exports = __webpack_public_path__ + "static/media/banner_4.dc50c508.webp";